import { NgModule, ModuleWithProviders } from '@angular/core';

import { FishModalBackdrop } from './modal-backdrop';
import { FishModalWindow } from './modal-window';
import { FishModalStack } from './modal-stack';
import { FishModal } from './modal';

export { FishModal, FishModalOptions } from './modal';
export { FishModalRef, FishActiveModal } from './modal-ref';
export { ModalDismissReasons } from './modal-dismiss-reasons';


export class FishModalModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishModalModule, providers: [FishModal, FishModalStack] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishModalBackdrop, FishModalWindow],
  entryComponents: [FishModalBackdrop, FishModalWindow],
  providers: [FishModal]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
